import { InjectionToken, KeyValueDifferFactory } from '@angular/core';

export const KEY_VALUE_DIFFER_FACTORIES = new InjectionToken<KeyValueDifferFactory[]>('KEY_VALUE_DIFFER_FACTORIES');
